import _styled from "styled-components";
import { useTranslation } from 'react-i18next';
import { LevelIndicatorIcon } from '@restworld/utils-common';
import { Badge } from '@restworld/ui-ds-base';
import { Title } from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerInfoLevelCard(_ref) {
  var missingInfoCount = _ref.missingInfoCount,
      title = _ref.title,
      content = _ref.content,
      additionalContent = _ref.additionalContent;

  var _useEmployerInfoLevel = useEmployerInfoLevel(missingInfoCount),
      variant = _useEmployerInfoLevel.variant,
      text = _useEmployerInfoLevel.text;

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(LevelIndicatorIcon, {
        variant: variant
      }), /*#__PURE__*/_jsx(Title, {
        fontSize: "base",
        fontWeight: "semibold",
        textColor: "neutral-700",
        children: title
      }), /*#__PURE__*/_jsx(_StyledBadge, {
        variant: variant,
        children: text
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(InfoText, {
        children: content
      }), additionalContent && /*#__PURE__*/_jsx(InfoText, {
        children: additionalContent
      })]
    })]
  });
}
export default EmployerInfoLevelCard;
var InfoLevel;

(function (InfoLevel) {
  InfoLevel[InfoLevel["DANGER"] = 0] = "DANGER";
  InfoLevel[InfoLevel["WARNING"] = 1] = "WARNING";
  InfoLevel[InfoLevel["SUCCESS"] = 2] = "SUCCESS";
})(InfoLevel || (InfoLevel = {}));

function useEmployerInfoLevel(missingInfoCount) {
  var _useTranslation = useTranslation('common'),
      translateCommon = _useTranslation.t;

  var variant;
  var text;
  var level;
  if (missingInfoCount >= 5) level = InfoLevel.DANGER;else if (missingInfoCount > 1 && missingInfoCount < 5) level = InfoLevel.WARNING;else level = InfoLevel.SUCCESS;

  switch (level) {
    case InfoLevel.WARNING:
      variant = 'warning';
      text = translateCommon('missing');
      break;

    case InfoLevel.SUCCESS:
      variant = 'success';
      text = translateCommon('partial');
      break;

    default:
      variant = 'danger';
      text = translateCommon('insufficient');
  }

  return {
    variant: variant,
    text: text
  };
}

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-info-level-card__Wrapper",
  componentId: "sc-1t02mp3-0"
})(["", ""], {
  "minWidth": "320px",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "1rem"
});

var InfoText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "employer-info-level-card__InfoText",
  componentId: "sc-1t02mp3-1"
})(["", ""], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "employer-info-level-card___StyledDiv",
  componentId: "sc-1t02mp3-2"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.75rem"
});

var _StyledBadge = /*#__PURE__*/_styled(Badge).withConfig({
  displayName: "employer-info-level-card___StyledBadge",
  componentId: "sc-1t02mp3-3"
})({
  "width": "fit-content"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "employer-info-level-card___StyledDiv2",
  componentId: "sc-1t02mp3-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});